import { IconComponent } from "./types";

export const IconArrowRight: IconComponent = ({ fillColor }) => {
  return (
    <svg
      width="6"
      height="12"
      viewBox="0 0 6 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.61261 4.99908L1.11781 0.206563C0.704912 -0.234439 0 0.0775622 0 0.700064L0 11.3006C0 11.9231 0.704912 12.2336 1.11781 11.7941L5.61261 7.00159C6.12913 6.45109 6.12913 5.54958 5.61261 4.99908Z"
        fill={fillColor ?? "#555555"}
      />
    </svg>
  );
};

export default IconArrowRight;
